export default "__VITE_ASSET__DGvTBzYg__"